"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _default = {
  "macerata-feltria": {
    "10032dab": [{
      "hkey": "2a53d98e",
      "slug": "macerata-feltria",
      "name": "Macerata Feltria",
      "primary": true,
      "skipSearch": false
    }],
    "castellina": [{
      "hkey": "2a53d98e",
      "slug": "macerata-feltria",
      "name": "Macerata Feltria",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "65a8dee9": [{
      "hkey": "2a53d98e",
      "slug": "macerata-feltria",
      "name": "Macerata Feltria",
      "primary": true,
      "skipSearch": false
    }],
    "certalto": [{
      "hkey": "2a53d98e",
      "slug": "macerata-feltria",
      "name": "Macerata Feltria",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "bed66d13": [{
      "hkey": "2a53d98e",
      "slug": "macerata-feltria",
      "name": "Macerata Feltria",
      "primary": true,
      "skipSearch": false
    }],
    "grassano": [{
      "hkey": "2a53d98e",
      "slug": "macerata-feltria",
      "name": "Macerata Feltria",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "d9e28e81": [{
      "hkey": "2a53d98e",
      "slug": "macerata-feltria",
      "name": "Macerata Feltria",
      "primary": true,
      "skipSearch": false
    }],
    "mondagano": [{
      "hkey": "2a53d98e",
      "slug": "macerata-feltria",
      "name": "Macerata Feltria",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "abf753a4": [{
      "hkey": "2a53d98e",
      "slug": "macerata-feltria",
      "name": "Macerata Feltria",
      "primary": true,
      "skipSearch": false
    }],
    "san-vicino": [{
      "hkey": "2a53d98e",
      "slug": "macerata-feltria",
      "name": "Macerata Feltria",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "66c637b5": [{
      "hkey": "2a53d98e",
      "slug": "macerata-feltria",
      "name": "Macerata Feltria",
      "primary": true,
      "skipSearch": false
    }],
    "santa-lucia": [{
      "hkey": "2a53d98e",
      "slug": "macerata-feltria",
      "name": "Macerata Feltria",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "f36d8765": [{
      "hkey": "2a53d98e",
      "slug": "macerata-feltria",
      "name": "Macerata Feltria",
      "primary": true,
      "skipSearch": false
    }],
    "santa-maria-valcava": [{
      "hkey": "2a53d98e",
      "slug": "macerata-feltria",
      "name": "Macerata Feltria",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }]
  }
};
exports["default"] = _default;